import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';
import { format } from 'date-fns';

interface WaiterBumpWarningModalProps {
  open: boolean;
  onClose: () => void;
  ticketId: string;
  customerName: string;
  scheduledTime: Date;
  bumpAmount: number;
  flexThreshold: number;
  techId: string;
  techName: string;
  onReassignWaiter: () => void;
  onReassignBlockers: () => void;
}

export function WaiterBumpWarningModal({
  open,
  onClose,
  customerName,
  scheduledTime,
  bumpAmount,
  flexThreshold,
  techName,
  onReassignWaiter,
  onReassignBlockers,
}: WaiterBumpWarningModalProps) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-warning" />
            Waiter Appointment Running Late
          </DialogTitle>
          <DialogDescription className="space-y-2 pt-2">
            <p>
              <strong>{customerName}</strong> was scheduled for {format(scheduledTime, 'h:mm a')} 
              {' '}with <strong>{techName}</strong>
            </p>
            <p className="text-destructive font-medium">
              Now {bumpAmount} minutes late (max allowed: {flexThreshold} min)
            </p>
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-3 pt-4">
          <Button 
            onClick={onReassignWaiter}
            className="w-full"
            variant="default"
          >
            Reassign Waiter Ticket
          </Button>
          <Button 
            onClick={onReassignBlockers}
            className="w-full"
            variant="outline"
          >
            Reassign Blocking Tickets
          </Button>
          <Button 
            onClick={onClose}
            className="w-full"
            variant="ghost"
          >
            Dismiss
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
